import 'isomorphic-fetch';
import React from 'react'
import ReactDOM from 'react-dom';

// NPM Packages
import axios from 'axios';
import {flashMessage} from 'redux-flash';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk'
import {Router, Route, Redirect, hashHistory} from 'react-router';
import {syncHistoryWithStore, routerMiddleware} from 'react-router-redux';
import {middleware as flashMiddleware} from 'redux-flash';
import {persistStore, persistReducer} from 'redux-persist';
import {createHashHistory, useBasename} from 'history';
import {syncTranslationWithStore, setLocale} from 'react-redux-i18n';
import storage from 'redux-persist/lib/storage';
import {PersistGate} from 'redux-persist/es/integration/react';
import {Provider as AlertProvider} from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';

import asyncComponent from './AsyncComponent';
import {setLanguages} from '../core/store/actions/language';
import reducers from './store/reducers';
import Config from './config';
import {isLogged} from "./helpers/Helpers";

if (!global._babelPolyfill) {
    require('babel-polyfill');
}

const authorizationIsOn = true;
let client = document.getElementById('application').getAttribute('data-client');
let initialLoad = true;
let initialRoute = document.getElementById('application').getAttribute('data-initial-route');

const viewportmeta = document.querySelector('meta[name=viewport]');
viewportmeta.setAttribute('content', "initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0");
/**
 * Log out version
 */
console.log(`${client} version: 0.9.97`);
/**
 * Async components: Frontend Layout
 */
const FrontLayout = asyncComponent(() => import('./components/Layouts/FrontLayout'));
const LoginLayout = asyncComponent(() => import('./components/Layouts/LoginLayout'));

/**
 * Async components: Frontend
 */

const Home = asyncComponent(() => import('./pages/Home'));
const Page = asyncComponent(() => import('./pages/Page'));
const Preview = asyncComponent(() => import('./pages/Preview'));

/**
 * Middleware
 */
const middleware = [
    thunkMiddleware,
    flashMiddleware(),
    routerMiddleware(hashHistory)
];

/**
 * Persist
 */
const persist = persistReducer({
    key: 'root',
    storage: storage,
    blacklist: [
        'flash',
        'routing',
        'media',
        'i18n'
    ]
}, reducers);

/**
 * Store configuration
 */
const store = createStore(persist, applyMiddleware(...middleware));

/**
 * Language sync
 */
syncTranslationWithStore(store);

// store.dispatch(loadTranslations(translations));
if (isLogged() && authorizationIsOn) {
    store.dispatch(setLocale(Config.language));
    store.dispatch(setLanguages());
}

const gate = persistStore(store);
const basename = window.location.pathname + window.location.search;

const browserHistory = useBasename(createHashHistory)({
    basename: basename === '/' ? '' : ''
});

const history = syncHistoryWithStore(browserHistory, store);

/**
 * Configure axios
 */
axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    // let message = 'Something went wrong. Please try again!';
    // store.dispatch(
    //     flashMessage(message, {
    //         timeout: 0,
    //         props: {
    //             type: 'error'
    //         }
    //     })
    // );

    return Promise.reject(error);
});

/**
 * With Frontend layout
 */
const withFrontendLayout = (WrappedComponent, frontendTheme, pageId) => {


    return class WithAuthorization extends React.Component {
        componentDidMount() {
            document.body.classList.add('front-page');

            if (frontendTheme) {
                document.body.classList.add(frontendTheme);
            }
        }

        componentWillMount() {
            const {location: {pathname}} = this.props;

            if (initialLoad && initialRoute) {
                if (initialRoute !== pathname && pathname === '/') {
                    window.location.replace(window.location.href + initialRoute);
                    initialLoad = false;
                }
            }
        }

        render() {
            let props = this.props;

            if (!isLogged() && authorizationIsOn) {
                return (
                    <LoginLayout {...this.props}>
                    </LoginLayout>
                );
            } else {
                if (pageId) {
                    props.params.page = pageId;
                }
                if (WrappedComponent) {
                    return (
                        <FrontLayout {...props} frontendTheme={frontendTheme}>
                            <WrappedComponent {...props} frontendTheme={frontendTheme}/>
                        </FrontLayout>
                    );
                } else {
                    return (
                        <FrontLayout {...props} frontendTheme={frontendTheme}>
                        </FrontLayout>
                    );
                }
            }
        }
    }
};

const alertOptions = {
    position: 'middle',
    timeout: 99999999999,
    transition: 'fade',
    type: 'success'
}

/**
 * Frontend routes
 */
client &&
ReactDOM.render(
    <AlertProvider template={AlertTemplate} className='alert-dialog' {...alertOptions}>
        <Provider store={store}>
            <PersistGate persistor={gate}>
                <Router history={history}>
                    <Route
                        path="/"
                        component={withFrontendLayout(Home, client)}
                    />
                    <Route
                        path="/preview"
                        component={withFrontendLayout(Preview, client)}
                    />
                    <Route
                        path="/page/:page"
                        component={withFrontendLayout(Page, client)}
                    />
                    <Redirect from="*" to="/page/5"/>
                </Router>
            </PersistGate>
        </Provider>
    </AlertProvider>,
    document.getElementById('application')
);

export {
    basename,
    store
};


// WEBPACK FOOTER //
// ./src/frontend/index.js